import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <thead class="topic-list-header">
  {{raw
    "topic-list-header"
    canBulkSelect=this.canBulkSelect
    toggleInTitle=this.toggleInTitle
    hideCategory=this.hideCategory
    showPosters=this.showPosters
    showLikes=this.showLikes
    showOpLikes=this.showOpLikes
    order=this.order
    ascending=this.ascending
    sortable=this.sortable
    listTitle=this.listTitle
    bulkSelectEnabled=this.bulkSelectEnabled
    bulkSelectHelper=this.bulkSelectHelper
    experimentalTopicBulkActionsEnabled=this.experimentalTopicBulkActionsEnabled
    canDoBulkActions=this.canDoBulkActions
    showTopicsAndRepliesToggle=this.showTopicsAndRepliesToggle
    newListSubset=this.newListSubset
    newRepliesCount=this.newRepliesCount
    newTopicsCount=this.newTopicsCount
  }}
</thead>

<PluginOutlet
  @name="before-topic-list-body"
  @outletArgs={{hash
    topics=this.topics
    selected=this.selected
    bulkSelectEnabled=this.bulkSelectEnabled
    lastVisitedTopic=this.lastVisitedTopic
    discoveryList=this.discoveryList
    hideCategory=this.hideCategory
  }}
/>

<tbody class="topic-list-body">
  {{#each this.filteredTopics as |topic index|}}
    <TopicListItem
      @topic={{topic}}
      @bulkSelectEnabled={{this.bulkSelectEnabled}}
      @showTopicPostBadges={{this.showTopicPostBadges}}
      @hideCategory={{this.hideCategory}}
      @showPosters={{this.showPosters}}
      @showLikes={{this.showLikes}}
      @showOpLikes={{this.showOpLikes}}
      @expandGloballyPinned={{this.expandGloballyPinned}}
      @expandAllPinned={{this.expandAllPinned}}
      @lastVisitedTopic={{this.lastVisitedTopic}}
      @selected={{this.selected}}
      @lastChecked={{this.lastChecked}}
      @tagsForUser={{this.tagsForUser}}
      @focusLastVisitedTopic={{this.focusLastVisitedTopic}}
      @index={{index}}
    />
    {{raw
      "list/visited-line"
      lastVisitedTopic=this.lastVisitedTopic
      topic=topic
    }}
    <PluginOutlet
      @name="after-topic-list-item"
      @outletArgs={{hash topic=topic index=index}}
      @connectorTagName="tr"
    />
  {{/each}}
</tbody>

<PluginOutlet
  @name="after-topic-list-body"
  @outletArgs={{hash
    topics=this.topics
    selected=this.selected
    bulkSelectEnabled=this.bulkSelectEnabled
    lastVisitedTopic=this.lastVisitedTopic
    discoveryList=this.discoveryList
    hideCategory=this.hideCategory
  }}
/>
*/
{
  "id": "NedHfSdA",
  "block": "[[[10,\"thead\"],[14,0,\"topic-list-header\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"topic-list-header\"],[[\"canBulkSelect\",\"toggleInTitle\",\"hideCategory\",\"showPosters\",\"showLikes\",\"showOpLikes\",\"order\",\"ascending\",\"sortable\",\"listTitle\",\"bulkSelectEnabled\",\"bulkSelectHelper\",\"experimentalTopicBulkActionsEnabled\",\"canDoBulkActions\",\"showTopicsAndRepliesToggle\",\"newListSubset\",\"newRepliesCount\",\"newTopicsCount\"],[[30,0,[\"canBulkSelect\"]],[30,0,[\"toggleInTitle\"]],[30,0,[\"hideCategory\"]],[30,0,[\"showPosters\"]],[30,0,[\"showLikes\"]],[30,0,[\"showOpLikes\"]],[30,0,[\"order\"]],[30,0,[\"ascending\"]],[30,0,[\"sortable\"]],[30,0,[\"listTitle\"]],[30,0,[\"bulkSelectEnabled\"]],[30,0,[\"bulkSelectHelper\"]],[30,0,[\"experimentalTopicBulkActionsEnabled\"]],[30,0,[\"canDoBulkActions\"]],[30,0,[\"showTopicsAndRepliesToggle\"]],[30,0,[\"newListSubset\"]],[30,0,[\"newRepliesCount\"]],[30,0,[\"newTopicsCount\"]]]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,1],null,[[\"@name\",\"@outletArgs\"],[\"before-topic-list-body\",[28,[37,2],null,[[\"topics\",\"selected\",\"bulkSelectEnabled\",\"lastVisitedTopic\",\"discoveryList\",\"hideCategory\"],[[30,0,[\"topics\"]],[30,0,[\"selected\"]],[30,0,[\"bulkSelectEnabled\"]],[30,0,[\"lastVisitedTopic\"]],[30,0,[\"discoveryList\"]],[30,0,[\"hideCategory\"]]]]]]],null],[1,\"\\n\\n\"],[10,\"tbody\"],[14,0,\"topic-list-body\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"filteredTopics\"]]],null]],null],null,[[[1,\"    \"],[8,[39,5],null,[[\"@topic\",\"@bulkSelectEnabled\",\"@showTopicPostBadges\",\"@hideCategory\",\"@showPosters\",\"@showLikes\",\"@showOpLikes\",\"@expandGloballyPinned\",\"@expandAllPinned\",\"@lastVisitedTopic\",\"@selected\",\"@lastChecked\",\"@tagsForUser\",\"@focusLastVisitedTopic\",\"@index\"],[[30,1],[30,0,[\"bulkSelectEnabled\"]],[30,0,[\"showTopicPostBadges\"]],[30,0,[\"hideCategory\"]],[30,0,[\"showPosters\"]],[30,0,[\"showLikes\"]],[30,0,[\"showOpLikes\"]],[30,0,[\"expandGloballyPinned\"]],[30,0,[\"expandAllPinned\"]],[30,0,[\"lastVisitedTopic\"]],[30,0,[\"selected\"]],[30,0,[\"lastChecked\"]],[30,0,[\"tagsForUser\"]],[30,0,[\"focusLastVisitedTopic\"]],[30,2]]],null],[1,\"\\n    \"],[1,[28,[35,0],[\"list/visited-line\"],[[\"lastVisitedTopic\",\"topic\"],[[30,0,[\"lastVisitedTopic\"]],[30,1]]]]],[1,\"\\n    \"],[8,[39,1],null,[[\"@name\",\"@outletArgs\",\"@connectorTagName\"],[\"after-topic-list-item\",[28,[37,2],null,[[\"topic\",\"index\"],[[30,1],[30,2]]]],\"tr\"]],null],[1,\"\\n\"]],[1,2]],null],[13],[1,\"\\n\\n\"],[8,[39,1],null,[[\"@name\",\"@outletArgs\"],[\"after-topic-list-body\",[28,[37,2],null,[[\"topics\",\"selected\",\"bulkSelectEnabled\",\"lastVisitedTopic\",\"discoveryList\",\"hideCategory\"],[[30,0,[\"topics\"]],[30,0,[\"selected\"]],[30,0,[\"bulkSelectEnabled\"]],[30,0,[\"lastVisitedTopic\"]],[30,0,[\"discoveryList\"]],[30,0,[\"hideCategory\"]]]]]]],null]],[\"topic\",\"index\"],false,[\"raw\",\"plugin-outlet\",\"hash\",\"each\",\"-track-array\",\"topic-list-item\"]]",
  "moduleName": "discourse/components/topic-list.hbs",
  "isStrictMode": false
});